module.exports = __webpack_public_path__ + "img/loading.37d830a0.gif";